import Enum from '@/modules/core/app/helpers/Enum';
import { ReadReceipt } from '@/modules/readreceipt/models/ReadReceipt';

export class DocumentBadgeType extends Enum {
  key!: string;

  static NEW: DocumentBadgeType = { key: 'new' };
  static EDITED: DocumentBadgeType = { key: 'edited' };

  static isNewType(type: string | null | undefined): boolean {
    return type === DocumentBadgeType.NEW.key;
  }

  static isEditedType(type: string | null | undefined): boolean {
    return type === DocumentBadgeType.EDITED.key;
  }

  static fromReadReceipt(receipt: ReadReceipt): string | null {
    if (receipt.isActionTypeCreated()) {
      return DocumentBadgeType.NEW.key;
    }

    if (receipt.isActionTypeUpdated()) {
      return DocumentBadgeType.EDITED.key;
    }
    
    return null;
  }
}
